import './accordion.js';
import './carousel.js';
import './dropdown.js';
import './nav.js';
import './product-slider.js';
import './slider.js';
